// @flow
export const DOCUMENT_PUBLIC_OFFER: 'public_offer' = 'public_offer';
export const DOCUMENT_PRIVACY_POLICY: 'privacy_policy' = 'privacy_policy';
export const DOCUMENT_PRIVACY_CONSENT: 'privacy_consent' = 'privacy_consent';
